module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_14.045c41c9.gif";